import styled from '@emotion/styled';
import { r } from '../../../shared/lib/responsive';
import { PromoCtaButton } from '../../../shared/ui/promo-cta';

export const Button = styled(PromoCtaButton)`
  ${r('gap', 4)}
  background: var(--color-cta-reward);
  color: var(--color-text-on-dark);
  white-space: nowrap;
  overflow: hidden;

  &:hover:not(:disabled) {
    background: #0fb04b;
  }
`;

export const PointBadge = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  ${r('width', 23)}
  ${r('height', 23)}
  border-radius: 50%;
  background: var(--color-card-active);
  color: var(--color-cta-reward);
  font-weight: var(--font-weight-extrabold);
  font-size: var(--type-cta-size);
  line-height: 1;
`;

export const PointValue = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  min-width: 2.2ch;
  font-weight: var(--font-weight-extrabold);
  font-size: var(--type-cta-size);
  line-height: 1;
  color: var(--color-text-on-dark);
`;

export const Message = styled.span`
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: var(--font-weight-bold);
  font-size: var(--type-cta-size);
  line-height: 1;
  color: var(--color-text-on-dark);
`;
